module.exports = __webpack_public_path__ + "static/media/GA-2100BWP-2AER_OR01.73d33549.png";